var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading-content',{staticClass:"md-primary",attrs:{"error":"","error-icon":"lock","error-label":"Area restringida.","error-description":_vm.erroDescription}},[_c('div',{staticClass:"md-group"},[_c('md-button',{staticClass:"md-round md-sm md-warning",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('md-icon',[_vm._v(" keyboard_arrow_left ")]),_vm._v("\n      Atras\n    ")],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Errors/403.vue